import { getPathnameFromFilePath } from "../../utils/getPathnameFromFilePath";
function getPathFromRoute(route) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var params = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = route.file.matchAll(/\[([^\]]+)\]/g)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [param, inner] = _step.value;
      params[inner] = param;
      params[inner.replace(/^\.\.\./, "")] = param;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return getPathnameFromFilePath(route.file, params, false, {
    ...options,
    preserveExtensions: true
  }).replace(/^\.\//, "/").replace(/\/+$/, "");
}
export {
  getPathFromRoute
};
//# sourceMappingURL=getPathFromRoute.js.map
